<!-- <div> 
  <div class="ttmodal__header">
      <span class="ttmodal__title" style="font-size: 20px;">Detailed Compartment View</span>
      <i class="material-icons ttmodal__close-button" style="margin-left: 60%; cursor: pointer;" (click)="onCloseClick()">close</i>
  </div>
  <div class="ttmodal__body">
  </div>
</div> -->



<div class="ttmodal" >
  <div class="ttmodal__header" style="margin-bottom: 15px">
    <span class="ttmodal__title" style="font-size: 20px;">{{Name}} Detailed Compartment View</span>
    <i class="material-icons ttmodal__close-button" style="cursor: pointer;" (click)="onCloseClick()">close</i>


  </div>

  <div class="margin-bottom-24" style="overflow-x: auto; white-space: nowrap">
        <div style="margin-left: 39%;"  *ngIf="schematicList.length==0" >
        <mat-spinner> </mat-spinner>
    </div>
    <ng-container *ngFor="let sch of schematicList">
      <ng-container *ngIf="sch.ObservationPoints.length>0">
        <div class="implement-image-container2">
            <!-- <img [src]="getImage(sch.Data)" style="width: 100%; height: 100%;" /> -->
            <app-crack-obspoint-schematic [SchematicOP]="sch.ObservationPoints" [schematicData]="sch" [isCrack]="2"style="position: relative;" ></app-crack-obspoint-schematic>
            <span style="font-size: small;display: flex; justify-content: space-around;">{{sch.ImageName}}</span>
        </div>
    </ng-container>
    </ng-container>
</div>


  <div  style="overflow-y: auto; height:100%; ">

    <div style="display: flex;flex-direction: row;">         
      <!-- <div style="margin-left: 39%;"  *ngIf="loading" >
        <mat-spinner> </mat-spinner>
    </div> -->
          <div> 
                
        <table class="table table--striped table--full-width" style="border-right: groove;">
          <thead>           
            
            <tr>             
            <th></th>       
            <ng-container *ngFor="let equ of EquipmentList">      
            <th style="text-align: center; border-right: groove;" colspan="3">{{equ.serialNO}}</th> 
            </ng-container>                      
            </tr>
            <tr>
              <td></td>
              <ng-container *ngFor="let equ of EquipmentList"> 
              <td style="padding: 8px 10px;font-weight: bold;"># Cracks</td>
              <td style="padding: 8px 10px;font-weight: bold;">T/Length</td>
              <td style="padding: 8px 10px;font-weight: bold;border-right: groove;">Avg Length</td> 
            </ng-container>              
            </tr>
         
          </thead>          
            <tbody>
              <ng-container *ngFor="let im of implementTypeListForTable_">
                <tr style="cursor: pointer;" >
                    <td style="text-align: left;padding: 20px 25px; white-space: nowrap;border-right: groove;"> {{im.Name}}</td>
                
                <ng-container *ngFor="let eq of EquipmentList">
                 <ng-container *ngIf="showValue(eq.euipmentID,im)">
                <ng-container *ngFor="let e of im.Equipment">                       
                    <ng-container *ngIf="e.euipmentID== eq.euipmentID">
                       
                        <td style="text-align: left; cursor: pointer;"  (click)="NavigateCrackRegister(e.euipmentID)">{{e.numberofcracks}}</td>
                        <td style="text-align: left; cursor: pointer;"  (click)="NavigateCrackRegister(e.euipmentID)" >{{e.totalcrackLength}}</td>
                        <td style="text-align: left; cursor: pointer;border-right: groove;"  (click)="NavigateCrackRegister(e.euipmentID)">{{e.AvgCrackLength>0? e.AvgCrackLength.toFixed(1):0}}</td>
                        
                        
                     </ng-container>                     
                 </ng-container>                                 
                </ng-container>
                <td *ngIf="!im.isPrint" ></td>
                <td *ngIf="!im.isPrint" ></td>
                <td *ngIf="!im.isPrint" style="border-right: groove;" ></td>
            </ng-container>
            </tr>
            </ng-container>
              <!-- <tr>      -->
                <!-- <td style="text-align: left; cursor: pointer;" >{{eq.numberofcracks}}</td>
                <td style="text-align: left; cursor: pointer;" >{{eq.totalcrackLength}}</td>
                <td  style="text-align: left; cursor: pointer;"> {{eq.AvgCrackLength>0? eq.AvgCrackLength.toFixed(1):0}} </td>  -->
              <!-- </tr> -->
            </tbody>
        </table>
      </div>
     
    </div>
  </div>

</div>

<!-- <schemantic-op-popup *ngIf="showSchematic" [(positionX)]="schematicPositionX" [(positionY)]="schematicPositionY"
[(currentStep)]="currentStep" [(mouseoverMPId)]="mouseoverMPId" [(mouseoverOPId)]="mouseoverOPId"
[(CustomerId)]="selectedCustomer" [(ImplementId)]="selectedImplement" 
[schematic]="selectedSchematic"
(closeSchematicWindow)="onCloseSchematicWindow($event);" (saveObservation)="onSaveObservation($event)" 
 [(title)]="draggableSchematicTitle" [(isTemplate)]="isTemplate"></schemantic-op-popup> -->